/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_4_ChangeInputs */

const en_privacy_section_4_change = /** @type {(inputs: Privacy_Section_4_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can change your cookie preferences at any time by reopening the consent dialog or clearing your browser's local storage and cookies for our site.`)
};

const lv_privacy_section_4_change = /** @type {(inputs: Privacy_Section_4_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sīkdatņu iestatījumus varat mainīt jebkurā laikā, atkārtoti atverot piekrišanas dialogu vai dzēšot šīs vietnes datus pārlūka lokālajā krātuvē un tās sīkdatnes.`)
};

/**
* | output |
* | --- |
* | "You can change your cookie preferences at any time by reopening the consent dialog or clearing your browser's local storage and cookies for our site." |
*
* @param {Privacy_Section_4_ChangeInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_4_change = /** @type {((inputs?: Privacy_Section_4_ChangeInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_4_ChangeInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_4_change(inputs)
	return en_privacy_section_4_change(inputs)
});